import { useState } from "react";
import { GlobalMenu } from "./GlobalMenu";
import { UserMenuModal } from "@/common/UserMenuModal";

type PageWrapperProps = {
  children?: React.ReactNode;
  headerCenter?: React.ReactNode;
  headerRight?: React.ReactNode;
};
export const PageWrapper = ({ children, headerCenter, headerRight }: PageWrapperProps) => {
  const [active, setActive] = useState("home");
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  return (
    <div className="flex min-h-screen w-full flex-col">
      {/* 背景画像: 画面固定、下から0、右から1/4隠れる、高さ画面の半分 */}
      <div className="fixed top-0 -z-10 h-full w-full ">
        <div className="relative mx-auto h-full max-w-md ">
          <div className="absolute -right-16 bottom-0 h-[340px]">
            <img src="/logo-icon.svg" alt="background" className="h-full w-auto opacity-30" />
          </div>
        </div>
      </div>
      <header className="z-10">
        {headerCenter || headerRight ? (
          // ヘッダーコンポーネントがある場合は3列レイアウト
          <div className="h-18 mx-auto grid max-w-md grid-cols-3 items-center gap-2 p-4">
            {/* 左側: ロゴ（固定幅） */}
            <div className="flex items-center justify-start">
              <h1 className="font-semibold">
                <img
                  src="/logo-type.svg"
                  alt="logo"
                  className="ml-1 h-8 cursor-pointer opacity-70 transition-opacity hover:opacity-100"
                  onClick={() => setIsUserMenuOpen(true)}
                />
              </h1>
            </div>
            {/* 中央: headerCenter */}
            <div className="flex items-end justify-center">{headerCenter}</div>
            {/* 右側: headerRight（固定幅） */}
            <div className="flex items-center justify-end">{headerRight}</div>
          </div>
        ) : (
          // 通常のレイアウト（ロゴのみ）
          <div className="h-18 mx-auto flex max-w-md items-center justify-start p-4">
            <h1 className="font-semibold">
              <img
                src="/logo-type.svg"
                alt="logo"
                className="ml-1 h-8 cursor-pointer opacity-70 transition-opacity hover:opacity-100"
                onClick={() => setIsUserMenuOpen(true)}
              />
            </h1>
          </div>
        )}
      </header>
      <div className="fixed bottom-0 z-50 -mb-8 w-full">
        <GlobalMenu active={active} setActive={setActive} />
      </div>
      <div className="z-0 mx-auto w-full max-w-md p-4 pb-28">
        <div className="block w-full">{children}</div>
      </div>
      <UserMenuModal open={isUserMenuOpen} onOpenChange={setIsUserMenuOpen} />
    </div>
  );
};
